import { render, staticRenderFns } from "./creditScoreDetail.vue?vue&type=template&id=19372280&scoped=true&"
import script from "./creditScoreDetail.vue?vue&type=script&lang=js&"
export * from "./creditScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./creditScoreDetail.vue?vue&type=style&index=0&id=19372280&prod&lang=less&scoped=true&"
import style1 from "./creditScoreDetail.vue?vue&type=style&index=1&id=19372280&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19372280",
  null
  
)

export default component.exports